import { lazy } from 'react';
import type { ComponentType } from 'react';

/**
 * Retry wrapper for lazy imports — handles stale chunks after deployment.
 * If the chunk fails to load, reload the page once to get a fresh asset manifest.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry(factory: () => Promise<{ default: ComponentType<any> }>) {
  return lazy(() =>
    factory()
      .then((module) => {
        // Chunk loaded successfully — clear reload flag for future deploys
        sessionStorage.removeItem('chunk_reload');
        return module;
      })
      .catch((error: Error) => {
        const hasReloaded = sessionStorage.getItem('chunk_reload');
        if (!hasReloaded) {
          sessionStorage.setItem('chunk_reload', '1');
          window.location.reload();
          // Return a never-resolving promise to prevent rendering during reload
          return new Promise(() => {});
        }
        sessionStorage.removeItem('chunk_reload');
        throw error;
      }),
  );
}
